import RadioHybrid from "./RadioHybrid";

/**
 * Primitive Radio Element. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using styled-system props or styled() extension).
 */
const Radio = RadioHybrid;

export default Radio;
